import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {NgForOf, NgIf} from "@angular/common";
import {CustomDropdownComponent} from "../../../../shared/components/custom-dropdown/custom-dropdown.component";
import {TranslateModule} from "@ngx-translate/core";
import {ScrollableWallComponent} from "../../../../shared/components/scrollable-wall/scrollable-wall.component";
import {NotificationItemComponent} from "../../../../shared/components/notification-item/notification-item.component";
import {
  SkeletonNotificationsComponent
} from "../../../../shared/components/skeleton-cards/skeleton-notifications/skeleton-notifications.component";
import {Router, RouterLink} from "@angular/router";
import {MeService} from "../../../../core/services/me.service";
import {HttpService} from "../../../../core/services/http.service";
import {ParticipateService} from "../../../../core/services/participate.service";
import {PopupHelperService} from "../../../../core/services/popup-helper.service";
import {appConstants} from "../../../../constants";
import {EventManagerService} from "../../../../core/services/event-manager.service";
import {SocketMainService} from "../../../../core/services/socket/socket-main-service";
import {StorageService} from "../../../../core/services/storage.service";
import {DropdownComponent} from "../../../../ui-lib/dropdown/dropdown.component";


@Component({
  selector: 'app-notifications-dropdown',
  templateUrl: './notification-dropdown.component.html',
  standalone: true,
  imports: [
    NgIf,
    CustomDropdownComponent,
    TranslateModule,
    ScrollableWallComponent,
    NotificationItemComponent,
    SkeletonNotificationsComponent,
    RouterLink,
    NgForOf,
    DropdownComponent
  ],
  providers: [MeService, HttpService, ParticipateService, PopupHelperService],
  styleUrls: ['./notification-dropdown.component.scss']
})
export class NotificationDropdownComponent implements OnInit {
  notifications: any = []
  notSeenNotificationsCount: number = 0
  loading = false;
  initialInfo: any
  @Input() forMobile = false;
  modalNotification: any
  modalOptions: any
  types: any = appConstants.NOTIFICATIONTYPES;
  errorMessage: any
  next: any
  disputeOne: any
  opened = false;
  widgetOpened = false;
  message = '';

  constructor(private eventManager: EventManagerService,
              private meService: MeService,
              private router: Router,
              private socketService: SocketMainService
  ) { }

  ngOnInit(): void {
    this.eventManager.initialInfoEmitter.subscribe((data)=>{
      if(data.notSeenNotificationsCount !== undefined){
        this.initialInfo = data
        this.notSeenNotificationsCount = this.initialInfo?.notSeenNotificationsCount;
        if (Object.prototype.toString.call(this.notSeenNotificationsCount) === '[object Array]'){
          this.notSeenNotificationsCount = 0
        }
      }
    })

    this.socketService.listenToEventWithCallback(appConstants.ACTIONTYPES.UPDATE, appConstants.EVENTTYPES.USER, (data: any)=>{
      if(data.seenNotificationId){
        this.notSeenNotificationsCount = this.notSeenNotificationsCount - 1
        this.initialInfo.notSeenNotificationsCount = this.notSeenNotificationsCount;
        let initialInfo = StorageService.getJsonItem(StorageService.statics.initialInfo)
        initialInfo.notSeenNotificationsCount = this.notSeenNotificationsCount
        StorageService.setJsonItem(StorageService.statics.initialInfo, initialInfo)
      }
    })
    this.socketService.listenToEventWithCallback(appConstants.ACTIONTYPES.DELETE, appConstants.EVENTTYPES.USER, (data: any)=>{
      if(data.notification){
        if(data.notification.status === "notSeen"){
          this.notSeenNotificationsCount = this.notSeenNotificationsCount - 1
          this.initialInfo.notSeenNotificationsCount = this.notSeenNotificationsCount;
          let initialInfo = StorageService.getJsonItem(StorageService.statics.initialInfo)
          initialInfo.notSeenNotificationsCount = this.notSeenNotificationsCount
          StorageService.setJsonItem(StorageService.statics.initialInfo, initialInfo)
        }
        if(this.notifications){
          let index = this.notifications.map(function (e: any) {
            return e._id
          }).indexOf(data.notification._id)
          if (index >= 0) {
            this.notifications.splice(index, 1);
          }
        }
      }
    })
    this.socketService.listenToEventWithCallback(appConstants.ACTIONTYPES.ADD, appConstants.EVENTTYPES.USER, (data: any)=>{
      if(data.notification){
        this.notSeenNotificationsCount = this.notSeenNotificationsCount + 1
        this.initialInfo.notSeenNotificationsCount = this.notSeenNotificationsCount;
        if(this.notifications){
          this.notifications.unshift(data.notification)
        }
        if(data.notification.showWithPopup){
          this.modalNotification = data.notification
          this.eventManager.openNotificationModal(this.modalNotification)
        }
      }
    })
  }

  onOpen():void{
    if(this.forMobile){
      this.router.navigate(['/notifications']);
      return;
    }
    this.loading = true;
    this.eventManager.menuTrigger.emit(2);
    this.meService.getNotificationsList({limit: 8}).subscribe((data: any) => {
      this.loading = false;
      this.widgetOpened = true
      this.notifications = data.data.data
      this.next = data.data.next
    })
  }
  onClose():void{
    this.widgetOpened = false
    this.eventManager.menuTrigger.emit(-1);
  }
  loadMore(){
    if(this.next && this.next !== '' && !this.loading){
      this.loading = true;
      this.meService.getNotificationsList({limit: 8, next: this.next}).subscribe((data: any) => {
        if(!data.hasError){
          this.notifications = this.notifications.concat(data.data.data)
          this.next = data.data.next
        }
        this.loading = false;
      }, () => {
        this.loading = false;
      })
    }
  }
  seenAll(){
    this.meService.notificationSeenAll().subscribe((data: any) =>{
      if(!data.hasError){
        this.initialInfo = StorageService.getJsonItem(StorageService.statics.initialInfo)
        this.notSeenNotificationsCount = 0;
        this.initialInfo.notSeenNotificationsCount = 0;
        StorageService.setJsonItem(StorageService.statics.initialInfo, this.initialInfo)
        if(this.notifications){
          for (let i = 0; i < this.notifications.length; i++){
            if(this.notifications[i].status === appConstants.NotificationStatus.NOT_SEEN){
              this.notifications[i].status = appConstants.NotificationStatus.SEEN
            }
          }
        }
      }
    })
  }
}
